import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { LozengeLarge } from 'Packages/FacetDesign/Components/Lozenge';
import { TextInputSmall } from 'Packages/FacetDesign/Components/TextInput';
import { Description } from './Description';

export const leadPromoOverrides = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => LozengeLarge,
    _customProps: { color: 'info' },
  }, overrideReadOnly)
  .override({ name: 'description', hint: 'richtext' }, {
    _component: () => Description,
  }, overrideReadOnly)
  .nameOverride('code', {
    _component: () => TextInputSmall,
    _customProps: { fullWidth: true },
  }, overrideReadOnly)
  .done();
